import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface MachineUploadPayload {
    storeId: number;
    machineList: File;
}

export interface MachineUploadResponse {
    success: boolean;
}

export const uploadOfflineMachinesForStore = (params: FormData): AxiosPromise<MachineUploadResponse> => {
  return httpClient({
    method: 'POST',
    url: 'common/machines/upload/offline',
    headers: {
      'content-type': 'multipart/form-data',
    },
    data: params,
  });
};
